import _export from '../internals/export.js';
import mathFround from '../internals/math-fround.js';

var $ = _export;
var fround = mathFround; // `Math.fround` method
// https://tc39.es/ecma262/#sec-math.fround

$({
  target: 'Math',
  stat: true
}, {
  fround: fround
});
